<!-- =========================================================================================
  File Name: AttendeeAdd.vue
  Description: Attendee Edit Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Webspiders
  Author URL: https://www.webspiders.com
========================================================================================== -->
<template>
  <div id="page-attendee-add" class="attendee-form-wrap">
    <vs-tabs position="left">
      <vs-tab label="Default Feilds">
        <div class="vx-row">
          <div class="flex flex-wrap w-full">
            <div class="flex-grow">
              <vs-table :data="defaultFilterFields">
                <template slot="thead"> 
                  <vs-th></vs-th>               
                  <vs-th>Field Name</vs-th>
                  <vs-th>Display Label</vs-th>
                  <vs-th>Allow Multi Select</vs-th>
                  <vs-th>Operator</vs-th>
                  <vs-th>Options</vs-th>
                  <vs-th>Action</vs-th>
                </template>

                <template slot-scope="{ data }">
                  <vs-tr :key="indextr" v-for="(tr, indextr) in data">     
                    <vs-td>
                      <vs-checkbox v-model="selectedFields" :vs-value="data[indextr]" />
                    </vs-td>              
                    <vs-td>{{
                      data[indextr].FieldName
                    }}</vs-td>
                    <vs-td>
                    <vs-input v-model="data[indextr].DisplayLabel" />
                    </vs-td>
                    <vs-td><vs-switch v-model="data[indextr].AllowMultiSelect" /></vs-td>                  
                    <vs-td>
                      <v-select 
                      :clearable="false" 
                      :options="['==', 'in', 'array-contains', 'array-contains-any']" 
                      v-model="data[indextr].Operator" 
                      />
                    </vs-td>
                    <vs-td> 
                      <ul><li v-for="optn in data[indextr].Options">{{optn}}</li></ul>
                    </vs-td>
                    <vs-td >
                      <feather-icon
                        icon="RefreshCwIcon"
                        title="Edit Admin"
                        svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"                      
                      />                    
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </div>
        </div>
      </vs-tab>
      <vs-tab label="Dynamic Fields">
        <div class="vx-row">
          <div class="flex flex-wrap w-full">
            <div class="flex-grow">
              <vs-table :data="dynamicFilterFields">
                <template slot="thead"> 
                  <vs-th></vs-th>               
                  <vs-th>Field Name</vs-th>
                  <vs-th>Display Label</vs-th>
                  <vs-th>Allow Multi Select</vs-th>
                  <vs-th>Operator</vs-th>
                  <vs-th>Options</vs-th>
                  <vs-th>Action</vs-th>
                </template>

                <template slot-scope="{ data }">
                  <vs-tr :key="indextr" v-for="(tr, indextr) in data">     
                    <vs-td>
                      <vs-checkbox v-model="selectedFields" :vs-value="data[indextr]" />
                    </vs-td>              
                    <vs-td>{{
                      data[indextr].FieldName
                    }}</vs-td>
                    <vs-td>
                    <vs-input v-model="data[indextr].DisplayLabel" />
                    </vs-td>
                    <vs-td><vs-switch v-model="data[indextr].AllowMultiSelect" /></vs-td>                  
                    <vs-td>
                      <v-select 
                      :clearable="false" 
                      :options="['==', 'in', 'array-contains', 'array-contains-any']" 
                      v-model="data[indextr].Operator" 
                      />
                    </vs-td>
                    <vs-td> 
                      <ul><li v-for="optn in data[indextr].Options">{{optn}}</li></ul>
                    </vs-td>
                    <vs-td >
                      <feather-icon
                        icon="RefreshCwIcon"
                        title="Edit Admin"
                        svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"                      
                      />                    
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </div>
        </div>
      </vs-tab>
    </vs-tabs>
    <div class="row">
      <div class="vx-col flex justify-content-between align-items-center w-full text-right mb-5 event-admin-popup-header">
        <vs-button
          class="ml-auto"
          @click="saveFilterCriteria"
          >Save</vs-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
// Store Module
import moduleattendeeManagement from '@/store/attendee-management/moduleAttendeeManagement.js'
var vm;
export default {
  components: {
    "v-select": vSelect,
  },
  data () {
    return {
      defaultFilterCriterias: [],
      dynamicFilterCriterias: [],
      selectedFields: []
    }
  },
  watch: {
  },
  computed: {
    defaultFilterFields(){
      vm.selectedFields.forEach(item=>{
        let msgIndex = vm.defaultFilterCriterias.findIndex((u) => item.FieldName == u.FieldName)
        if(msgIndex >= 0){
          vm.defaultFilterCriterias[msgIndex] = item
        }
      })
      return vm.defaultFilterCriterias;
    },
    dynamicFilterFields(){
      vm.selectedFields.forEach(item=>{
        let msgIndex = vm.dynamicFilterCriterias.findIndex((u) => item.FieldName == u.FieldName)
        if(msgIndex >= 0){
          vm.dynamicFilterCriterias[msgIndex] = item
        }
      })
      return vm.dynamicFilterCriterias;
    }
  },
  methods: {
    getdefaultFilterCriterias(){
      vm.$vs.loading();
      vm.$store
        .dispatch("attendeeManagement/getdefaultFilterCriterias")
        .then((res) => {
          vm.defaultFilterCriterias = res;          
          vm.popupFilterCriteria = true;
          vm.$vs.loading.close();
        });
    },
    getdynamicFilterCriterias(){
      vm.$vs.loading();
      vm.$store
        .dispatch("attendeeManagement/getdynamicFilterCriterias")
        .then((res) => {
          vm.dynamicFilterCriterias = res;          
          vm.popupFilterCriteria = true;
          vm.$vs.loading.close();
        });
    },
    saveFilterCriteria(){
        vm.$vs.loading();
        vm.$store.dispatch("attendeeManagement/setfilterCriterias", this.selectedFields)
        .then((res) => {
          vm.selectedFields = [];
          this.$emit('closePopupFilterCriteria');
          vm.$vs.loading.close();
          this.$vs.notify({
              color: "success",
              position: "top-center",
              text: "Filters Added Successfully.",
            });
        }).catch(_=>{ vm.$vs.loading.close(); })
    }
    
  },
  created () {
    vm = this;
    // Register Module attendeeManagement Module
    if (!moduleattendeeManagement.isRegistered) {
      this.$store.registerModule('attendeeManagement', moduleattendeeManagement)
      moduleattendeeManagement.isRegistered = true
    } 
    this.getdefaultFilterCriterias();
    this.getdynamicFilterCriterias();
    this.$store.dispatch("attendeeManagement/getSavedfilterCriterias").then(res=>{
      if(res && res.DynamicFields.length)
        this.selectedFields = res.DynamicFields;      
    })
    
  }
}

</script>